import axios from 'axios';
import * as LocalStorage from './LocalStorage';
import { initializeCookieAuth } from './CookieAuth';

/** Matches ROI-Enrichment-FE `AINSTEIN_EMAIL_ACCESS_COOKIE` / TTL. */
export const AINSTEIN_EMAIL_ACCESS_COOKIE = 'ainstein_email_access';
export const AINSTEIN_EMAIL_ACCESS_TTL_SECONDS = 600;

/** UI-unblock timeout (ms): stops the loader if consent check hangs. */
export const CONSENT_CHECK_TIMEOUT_MS = 5000;

function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export function getCachedAinsteinEmailAccess() {
  return readCookie(AINSTEIN_EMAIL_ACCESS_COOKIE) === 'true';
}

export function setCachedAinsteinEmailAccess() {
  const maxAge = AINSTEIN_EMAIL_ACCESS_TTL_SECONDS;
  document.cookie = `${AINSTEIN_EMAIL_ACCESS_COOKIE}=true; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function clearCachedAinsteinEmailAccess() {
  document.cookie = `${AINSTEIN_EMAIL_ACCESS_COOKIE}=; path=/; max-age=0`;
}

/** Same token source as Ainstein Outlook connect (cookie SSO + localStorage). */
export function getAinsteinAuthToken() {
  return initializeCookieAuth() || LocalStorage.loadToken();
}

/**
 * GET /email/consent-status on Ainstein Core BE.
 * @param {string|null|undefined} authToken — raw JWT (no `Bearer ` prefix)
 * @returns {Promise<boolean>}
 */
export async function fetchConsentStatus(authToken) {
  if (getCachedAinsteinEmailAccess()) {
    return true;
  }
  const baseUrl = process.env.REACT_APP_AINSTEIN_CORE_BE_URL;
  if (!baseUrl) {
    throw new Error('REACT_APP_AINSTEIN_CORE_BE_URL is not defined');
  }
  const url = `${baseUrl.replace(/\/$/, '')}/email/consent-status`;
  const { data } = await axios.get(url, {
    headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    timeout: 10000
  });
  const hasAccess = data?.hasAccess ?? data?.result?.hasAccess;
  return Boolean(hasAccess);
}
